import React from 'react';
import {NeuroMessage, useProduct, useGuideConfig} from "@ignitesales/neuro-application";
import ProductActionButton from '../../../../../../shared/js/components/ProductActionButton';

const Product = ({product}) => {
    const {
        descriptionAbbreviated,
        disclosures,
        features,
        name,
        buttonText,
        onProductActionClick,
        url,
        applyUrl
    } = useProduct(product);
    const { isBranchGuide } = useGuideConfig();
    const componentClass = 'product';

    const renderProductFeatures = () => {
        return (features.length) ? <div className={ `${ componentClass }__features` }>
            <ol>{ features.map( (f,i) => <li key={i}>{f}</li>) }</ol>
        </div> : null;
    };

    const renderProductDisclosures = () => {
        return (disclosures.length) ? <div className={ `${ componentClass }__disclosures` }>
            <NeuroMessage id="product.disclosures.title" tagName="div" />
            <ol>{ disclosures.map( (f,i) => <li key={i}>{f}</li>) }</ol>
        </div> : null;
    };

    return <div className={componentClass}>
        <div className={`${componentClass}__title`}>
            <a href={url} target="_blank"><h4>{ name }</h4></a>
        </div>
        <div className={`${componentClass}__details`}>
            <span className={`${componentClass}__description`}>{ descriptionAbbreviated }</span>
            { renderProductFeatures() }
            { renderProductDisclosures() }
            { !isBranchGuide && <div className={`${componentClass}__actions`}>
                <ProductActionButton buttonText={buttonText} url={applyUrl} onClick={onProductActionClick} />
            </div> }
        </div>
    </div>;
};

export default Product;
